import { useState } from "react";
import "./InputFile.scss";

export default function InputFile({ children, accept, setFile }) {
  return (
    <div className="ui-input-file">
      <label>
        <input
          type="file"
          accept={accept}
          onChange={(event) => {
            // console.log("Выбор файла", accept, setFile, event.target.value);

            setFile(event.target.files[0]);
            // onSelect(event.target.files[0]);
          }}
        />
        {children}
      </label>
    </div>
  );
}
